import React, { useEffect, useState } from 'react';
import { Menu, Phone, X } from 'lucide-react';
import { BUSINESS, NAV_LINKS } from './data';
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-brand-ink/95 backdrop-blur shadow-lg' : 'bg-brand-ink'}`} data-id="element-96" data-mp="1om5am3daninm">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8" data-id="element-97" data-mp="1ykkyzykxsdtf">
        <a href="#top" className="flex items-center" aria-label={`${BUSINESS.name} home`} data-id="element-98" data-mp="3vd4pmszsmqo9">
          <img src={BUSINESS.logoWhite} alt={BUSINESS.name} className="h-11 w-auto sm:h-12" data-id="element-99" data-mp="46k41osicaym" />
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary" data-id="element-100" data-mp="2gnnou6arvmpq">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-white/80 transition-colors hover:text-white" data-id="element-101" data-mp="2buuhrbru02ah">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-102" data-mp="2zlzzjwhc14nf">
          <a href={BUSINESS.phoneHref} className="hidden items-center gap-2 rounded-full bg-brand-red px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-red-dark sm:inline-flex" data-id="element-103" data-mp="2zjnirmnb90by">
            <Phone className="h-4 w-4" data-id="element-104" data-mp="2lmi97coe1jby" />
            {BUSINESS.phoneDisplay}
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex h-10 w-10 items-center justify-center rounded-md text-white lg:hidden" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-105" data-mp="1f5mv20fh7n4z">
            {open ? <X className="h-6 w-6" data-id="element-106" data-mp="1gnbud2scsk4u" /> : <Menu className="h-6 w-6" data-id="element-107" data-mp="1glqwb36tyj28" />}
          </button>
        </div>
      </div>

      {open && <div className="border-t border-white/10 bg-brand-ink lg:hidden" data-id="element-108" data-mp="12mra026sig98">
          <nav className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4 sm:px-6" aria-label="Mobile" data-id="element-109" data-mp="16o4eo8y5cdek">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="rounded-md px-3 py-3 text-base font-medium text-white/85 hover:bg-white/5 hover:text-white" data-id="element-110" data-mp="svekhh8gs26d">
                {link.label}
              </a>)}
            <a href={BUSINESS.phoneHref} className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-brand-red px-5 py-3 text-base font-semibold text-white" data-id="element-111" data-mp="9yvgf6cip4go">
              <Phone className="h-4 w-4" data-id="element-112" data-mp="3rgivz75uh168" />
              {BUSINESS.phoneDisplay}
            </a>
          </nav>
        </div>}
    </header>;
}